import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { deleteUser, setUser } from "../slices/authSlice";
import { setTokens, getToken } from "../../utils/tokens";

const baseQuery = fetchBaseQuery({
  baseUrl: `${import.meta.env.VITE_APP_API}`,
  prepareHeaders: (headers, { getState, endpoint }) => {
    const noAuthEndpoints = ["loginOtp", "register", "loginByPassword"];
    // Skip Authorization header for specific endpoints
    if (!noAuthEndpoints.includes(endpoint)) {
      // Try to get the token from Redux state
      let token = getState()?.auth?.user?.token;
      // If not in state, fall back to the token stored in localStorage
      if (!token) {
        const localData = getToken();
        token = localData?.token;
      }
      if (token && token.access) {
        headers.set("Authorization", `Bearer ${token.access}`);
      }
    }
    // It's good to set the Content-Type here as well if your API expects JSON.
    // headers.set("Content-Type", "application/json");
    return headers;
  },
});

const baseQueryWithRefreshToken = async (args, api, extraOptions) => {
  let result = await baseQuery(args, api, extraOptions);
  if (result.error?.status === 401) {
    // Try to refresh the token
    const refreshResult = await baseQuery(
      {
        url: "/api/account/refresh",
        method: "POST",
        body: { refresh: api.getState()?.auth?.user?.token?.refresh },
      },
      api,
      extraOptions
    );

    if (refreshResult?.data?.access) {
      // Construct the new user object
      const user = {
        user: api.getState()?.auth?.user?.user,
        token: {
          access: refreshResult.data.access,
          refresh: api.getState()?.auth?.user?.token?.refresh,
        },
      };

      console.log("Refreshed user:", user);
      api.dispatch(setUser(user));
      setTokens(user);
      // Retry the original query with new token
      result = await baseQuery(args, api, extraOptions);
    } else {
      // If refresh fails, log out the user
      if (refreshResult.error?.status === 401) {
        api.dispatch(deleteUser());
      }
      return refreshResult;
    }
  }
  return result;
};

const mainApi = createApi({
  baseQuery: baseQueryWithRefreshToken,
  reducerPath: "mainApi",
  tagTypes: [
    "courses",
    "sections",
    "mentors",
    "routines",
    "preps",
    "descriptions",
    "videos",
    "update_photos",
    "exam_question",
    "lectures",
    "lectureItems",
  ],
  endpoints: () => ({}),
});

export default mainApi;
